var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagPl = function SvgIconFlagPl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M4 12h16a8 8 0 0 0-7.993-8h-.013A8 8 0 0 0 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D71F35",
    d: "M20 12H4a8 8 0 0 0 7.993 8h.015A8 8 0 0 0 20 12"
  }))));
};
export { SvgIconFlagPl as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGQ9Ik00IDEyaDE2YTcuOTk5IDcuOTk5IDAgMDAtNy45OTMtOGgtLjAxM0E4IDggMCAwMDQgMTIiIGZpbGw9IiNGRUZFRkUiLz48cGF0aCBkPSJNMjAgMTJINGE4IDggMCAwMDcuOTkzIDhoLjAxNUE4IDggMCAwMDIwIDEyIiBmaWxsPSIjRDcxRjM1Ii8+PC9nPjwvc3ZnPg==";